import React, {useRef, useEffect, useState} from 'react'
import { useParams } from "react-router-dom";
import Archive from '../Archive/Archive';
import Library from '../Library/Library';
import HistoricalArchive from '../HistoricalArchive/HistoricalArchive';
import "./PresentationView.css";

//  Mapea cada slide-id al tema que quieras
const themeMap = {
  // Library
  library:        "dark",
  release:        "light",
  news:           "dark",
  signer_headline:"light",
  features:       "light",
  modules:        "dark",
  cloud:          "dark",
  "about-cloud":  "light",
  thesis:         "dark",
  "about-thesis": "light",
  glifosforojs:   "dark",
  "about-glifosforojs":"light",
  "glifos-signer":"dark",
  "about-signer": "light",
  contactus:      "dark",

  // Archive
  archive_archive: "dark",
  archive_release: "light",
  archive_news:    "dark",   
  archive_signer_headline: "light",  
  archive_features:"light",
  archive_modules: "dark",
  archive_cloud:   "dark",
  "archive_about-cloud":"light",
  "archive_glifos-signer":"dark",
  "archive_about-signer": "light",
  archive_contactus: "dark",

  // HistoricalArchive
  hist_archive:        "dark",
  hist_release:        "light",
  hist_news:           "dark",
  hist_features:       "light",
  hist_modules:        "dark",
  hist_cloud:          "dark",
  "hist_about-cloud":  "light",
  hist_contactus:      "dark",
}

const PresentationView = () => {

    const { view } = useParams();
    const containerRef = useRef(null)
    const [navTheme, setNavTheme] = useState("dark")

    // const renderContent = () => {
    //     switch (view) {
    //       case "library": return <Library isPresentation />;
    //       case "enterprise-archive": return <Archive isPresentation />;
    //       case "digital-archive": return <HistoricalArchive isPresentation />;
    //       default: return <div>Not found</div>;
    //     }
    // }

    // Observer que actualiza navTheme al hacer snap
    useEffect(() => {
      if (!containerRef.current) return
      const slides = Array.from(containerRef.current.children)
      const obs = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              console.log(entry.target.id)
              const id = entry.target.id
              setNavTheme(themeMap[id] || "dark")
            }
          })
        },
        {
          root: containerRef.current,
          threshold: 0.6,
        }
      )
      slides.forEach(s => obs.observe(s))
      return () => obs.disconnect()
    }, [view])

    // funciones de scroll
    const handleNext = () => {
      containerRef.current?.scrollBy({ top: window.innerHeight, behavior: "smooth" })
    }
    const handlePrev = () => {
      containerRef.current?.scrollBy({ top: -window.innerHeight, behavior: "smooth" })
    }

    const renderSlides = () => {
      switch (view) {
        case "library": return <Library isPresentation idPrefix="" />
        case "enterprise-archive": return <Archive isPresentation idPrefix="archive_" />
        case "digital-archive": return <HistoricalArchive isPresentation idPrefix="hist_" />
        default: return <div>Not found</div>
      }
    }

    return (
      <>
        <main ref={containerRef} className="library_container">
          {renderSlides()}
        </main>
  
        <div className={`slide_nav ${navTheme}`}>
          <button onClick={handlePrev}>←</button>
          <button onClick={handleNext}>→</button>
        </div>
      </>
    )
};

export default PresentationView;
